import { Component, ChangeDetectionStrategy, OnInit, Inject } from '@angular/core';
import type { StateService as _StateService } from '@uirouter/core';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CollectionManageAccessFacade } from '@mode/collections/domain';
import { CollectionAccessLevel, SpaceType } from '@mode/shared/contract-common';

export enum CollectionManagerMethod {
  add = 'add',
  manage = 'manage',
}

// To deal with Angular not respecting the type import in a constructor
type StateService = _StateService;

@Component({
  selector: 'mode-access-dialogs-container',
  templateUrl: './access-dialogs-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessDialogsContainerComponent implements OnInit {
  entitlementsAdded!: boolean;
  method!: CollectionManagerMethod;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data: {
      collectionId: string;
      collectionType: SpaceType;
      workspaceName: string;
      overallAccess: CollectionAccessLevel;
      routingEnabled: boolean;
    },
    @Inject('$state') private $state: StateService,
    private collectionManageAccessFacade: CollectionManageAccessFacade
  ) {}

  ngOnInit() {
    this.entitlementsAdded = false;
    const method = this.$state.params.accessAction;

    this.setMethod(method);

    if (this.method === 'manage') {
      this.getEntitlements(this.data.workspaceName, this.data.collectionId);
    }
  }

  getEntitlements(orgName: string, spaceId: string) {
    this.collectionManageAccessFacade.getEntitlements(orgName, spaceId);
  }

  setMethod(mode?: CollectionManagerMethod) {
    if (mode) {
      this.method = mode;
    } else {
      this.method = CollectionManagerMethod.manage;
    }
  }

  showManageAccess(hasNewEntitlements = false) {
    if (this.data.routingEnabled) {
      this.$state.go('root.space.access.action', { ...this.$state.params, accessAction: 'manage' });
    }
    this.getEntitlements(this.data.workspaceName, this.data.collectionId);
    this.entitlementsAdded = hasNewEntitlements;

    this.setMethod(CollectionManagerMethod.manage);
  }

  showAddMembers() {
    if (this.data.routingEnabled) {
      this.$state.go('root.space.access.action', { ...this.$state.params, accessAction: 'add' });
    }
    this.entitlementsAdded = false;

    this.setMethod(CollectionManagerMethod.add);
  }
}
